import Axios from "axios";

export const setAuthorizationHeader = (token: string) =>
  (Axios.defaults.headers.common.Authorization = `Bearer ${token}`);

export const unsetAuthorizationHeader = () =>
  delete Axios.defaults.headers.common.Authorization;
